import React, {useState, useEffect}					from 'react';

import Input										from '../ressources/components/Input';
import DocumentItem									from '../ressources/components/Document';
import Load											from '../ressources/components/Load/Load';
import Modal										from '../ressources/components/Modal';

import {useAppSelector, useAppDispatch}				from '../app/hooks';
import {closeUpload, pushUpload, setUploadPercent}	from '../redux/documents/documents';
import {Document} 									from '../redux/documents/interface';
import {AllContract}								from '../redux/contracts/interface';

import {ft_genNotification, ft_pushNotification}	from '../ressources/functions/notification';
import {ft_getDocumentCreator}						from '../ressources/functions/document';

import img_upload									from '../ressources/images/icon/upload.svg';
import img_trash									from '../ressources/images/icon/trash.svg';

import LANGUAGE										from '../ressources/language';
import * as API										from '../ressources/API';

import './Contracts.css';

interface Props {
	editData?: AllContract,
	documents?: File[],
	setDocument?: (docuements: File[]) => void
}

function ContractDocuments(props: Props) {
	const dispatch = useAppDispatch();
	const user = useAppSelector(state => state.user.data);
	const users = useAppSelector(state => state.companyUsers.data);
	const documentsUpload = useAppSelector(state => state.documents.uploadDocument);
	const lang = useAppSelector(state => state.settings.lang);
	const idNotification = useAppSelector(state => state.notifications.lastId);

	const [contractDocuments, set_contractDocuments] = useState<Document[]>([]);
	const [modal, set_modal] = useState<null | {notValala: boolean, url: string, document: Document}>(null);
	const [load, set_load] = useState(false);

	const TEXTE = LANGUAGE(lang);

	useEffect(() => {
		if (!props.editData)
			return;

		set_load(true);
		set_contractDocuments([]);
		getContractDocument();
	}, [props.editData?._id]);

	function getContractDocument() {
		if (!props.editData)
			return;

		API.getContractNotValalaDocument(props.editData._id, user)
		.then((response) => {
			set_load(false);
			if (response && response.status)
				set_contractDocuments(response.data);
		});
	}

	function uploadFile(file: FileList | null) {
		if (!file || !file[0] || (!props.editData && !props.setDocument))
			return;

		if (props.setDocument && props.documents)
			props.setDocument([...props.documents, file[0]]);

		if (!props.editData || 'funderList' in props.editData)
			return;

		let error = null;

		if (file[0].size > 2097152)
			error = TEXTE.global.fileToBig;

		const index = documentsUpload.length;

		const dispatchData = {
			index,
			dispatch,
			function: setUploadPercent
		};

		const uploadFileData = {
			percent:  error || 0,
			filename: file[0].name,
			size:     file[0].size,
			id:       props.editData._id
		};

		dispatch(pushUpload(uploadFileData));

		if (!error) {
			API.uploadContractNotValalaDocument(props.editData._id, file[0], user, dispatchData)
			.then((response) => {
				if (!response || !response.status)
					return dispatch(setUploadPercent({index, percent: `error: ${response?.error || ''}`}));
				if (!props.editData || 'funderList' in props.editData)
					return;

				const notification = ft_genNotification(TEXTE, 'fileDownloadDone', img_upload, props.editData.name);

				ft_pushNotification(dispatch, idNotification, notification);
				getContractDocument();
			});
		}
	}

	function renderDocuments() {
		const onClickDelete = (document: Document) => {
			if (!props.editData)
				return;

			API.deleteContractNotValalaDocument(props.editData._id, document, user)
			.then((response) => {
				const notification = ft_genNotification(TEXTE, (!response || !response.status) ? 'error' : 'editSuccess', img_trash, response.error, (!response || !response.status) ? 'error' : 'success');

				ft_pushNotification(dispatch, idNotification, notification);
				getContractDocument();
			});
		};
		const render: React.ReactElement[] = [];

		if (props.editData && 'funderList' in props.editData) {
			props.editData.funderList.forEach((funder) => {
				if (!funder?.file)
					return;
				foundDocument = true;
				render.push(
					<DocumentItem
						isValala
						filename={funder.file.name}
						size={funder.file.size}
						creator={ft_getDocumentCreator(funder.file, users)}
						onClickDownload={() => props.editData && API.downloadContract(props.editData._id, funder.file, user)}
						onClick={async () => {
							if (!props.editData)
								return;

							const url = await API.downloadContract(props.editData._id, funder.file, user, true);

							set_modal({url: url as string, document: funder.file, notValala: false});
						}}
					/>
				);
			});
		}

		contractDocuments.forEach((document) => {
			foundDocument = true;
			render.push(
				<DocumentItem
					size={document.size}
					filename={document.name}
					onClickDelete={() => onClickDelete(document)}
					creator={ft_getDocumentCreator(document, users)}
					onClickDownload={() => (props.editData ? API.downloadContractNotValalaDocument(props.editData._id, document, user) : null)}
					onClick={async () => {
						if (!props.editData)
							return;

						const url = await API.downloadContractNotValalaDocument(props.editData._id, document, user, true);

						set_modal({url: url as string, document, notValala: true});
					}}
				/>
			);
		});

		return render;
	}

	function renderUploadDocuments() {
		const render: React.ReactElement[] = [];

		documentsUpload.forEach((uploadData, index) => {
			if (uploadData.isClose || uploadData.id !== props.editData?._id || uploadData.percent as number === 100)
				return;
			render.push(
				<DocumentItem
					size={uploadData.size}
					percent={uploadData.percent}
					filename={uploadData.filename}
					onClickDelete={() => dispatch(closeUpload(index))}
				/>
			);
		});

		props.documents?.forEach((file, index) => {
			render.push(
				<DocumentItem
					size={file.size}
					filename={file.name}
					percent={file.size > 2097152 ? TEXTE.global.fileToBig : ' '}
					onClickDelete={() => {
						if (!props.documents || !props.setDocument)
							return;
						const copy: File[] = [...props.documents];

						copy.splice(index, 1);
						props.setDocument(copy);
					}}
				/>
			);
		});

		return render;
	}

	let foundDocument = false;

	return (
		<div className={'deviceDocumentsContainer'}>
			{props.editData &&
				<span className={'deviceDocumentsTitle'}>{TEXTE.contract.contractDocument}</span>
			}
			{renderDocuments()}

			{load && <Load center />}
			{(!load && props.editData && !foundDocument) && <DocumentItem documentType={'contract'} />}

			{(!props.editData || !('funderList' in props.editData)) &&
				<>
					<span className={'deviceDocumentsTitle'}>{TEXTE.devices.downloadDocuments}</span>
					<Input
						type={'file'}
						onChangeFile={uploadFile}
						fileInputText={TEXTE.devices.deviceDocumentRules}
						accept={'gif,.jpg,.jpeg,.tiff,.png,.webp,.bmp,.pdf'}
					/>
					{renderUploadDocuments()}
				</>
			}

			{modal &&
				<Modal
					fullWidth
					onClose={() => set_modal(null)}
					confirmButtonText={TEXTE.global.download}
					confirmButton={() => {
						if (!props.editData)
							return;
						if (!modal.notValala)
							return API.downloadContract(props.editData._id, modal.document, user);
						API.downloadContractNotValalaDocument(props.editData._id, modal.document, user);
					}}
				>
					<embed src={modal.url} style={{width: '100%', height: '90vh'}} />
				</Modal>
			}
		</div>
	);
}

export default ContractDocuments;
